import * as React from 'react';
import { cn } from '../../lib/cn';

export type QuickReplyItem = string | { label: string; value?: string };

export interface QuickRepliesProps {
  items: QuickReplyItem[];
  onSelect?: (value: string) => void;
  align?: 'left' | 'right';
  className?: string;
}

/** Row of accent-soft chips — quick replies / starter prompts. */
export function QuickReplies({ items, onSelect, align = 'left', className }: QuickRepliesProps) {
  return (
    <div
      className={cn(
        'flex flex-wrap gap-[var(--space-1-5)]',
        align === 'right' ? 'justify-end' : 'justify-start',
        className,
      )}
    >
      {items.map((it, i) => {
        const label = typeof it === 'string' ? it : it.label;
        const value = typeof it === 'string' ? it : (it.value ?? it.label);
        return (
          <button
            key={`${label}-${i}`}
            type="button"
            onClick={() => onSelect?.(value)}
            className={cn(
              'cursor-pointer rounded-pill border border-accent-line bg-accent-soft px-3 py-[var(--space-1-5)]',
              'font-sans text-sm font-semibold text-accent transition-colors duration-[var(--duration-fast)]',
              'hover:bg-accent-line',
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
